module.exports = __webpack_public_path__ + "img/DPD BELL logo_w.bfcd4b45.png";